import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import WebriQForm from "@webriq/gatsby-webriq-form"

const footer = ({ props }) => {
  return (
    <div>
      <div className="section_padding girl_bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-5 text-start section-heading mb-5">
              <h2 className="section-title text-start ">
                Contact us to discuss how we can help empower you on your
                investment journey.
              </h2>
              <h4>
                Please tell us about yourself, and our team will contact you.{" "}
              </h4>
            </div>
            <div className="col-md-6 offset-lg-1">
              <div className="contact-form">
                <WebriQForm
                  data-form-id="3e1e62c8-bdda-4bc7-a81c-b46ccb770ac3"
                  name="Partnership Opportunities"
                  className="form-newsletter"
                  method="POST"
                >
                  <div className="">
                    <div className="col-12">
                      <div className="row">
                        <div className=" col-md-6">
                          <small className="form-text mt-2">First Name *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="First Name"
                              id="fname"
                              required
                              aria-label="first name"
                            />
                          </div>
                        </div>
                        <div className=" col-md-6">
                          <small className="form-text mt-2">Last Name *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="Last Name"
                              id="lname"
                              required
                              aria-label="Last Name"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" col-md-12 mb-3">
                      <small className="form-text mt-2">Country *</small>
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          name="Country"
                          id="country"
                          required
                          aria-label="Country"
                        />
                      </div>
                    </div>
                    <div className=" col-md-12 mb-3">
                      <small className="form-text mt-2">Address *</small>
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          name="Address"
                          id="address"
                          required
                          aria-label="Address"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-6 col-lg-4">
                          <small className="form-text mt-2">City *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="City"
                              id="city"
                              required
                              aria-label="City"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <small className="form-text mt-2">State *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="State"
                              id="state"
                              required
                              aria-label="State"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <small className="form-text mt-2">ZIP *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="ZIP"
                              id="zip"
                              required
                              aria-label="ZIP"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className=" col-md-6">
                          <small className="form-text mt-2">
                            Phone Number *
                          </small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="text"
                              name="Phone Number"
                              id="phone"
                              required
                              aria-label="Phone Number"
                            />
                          </div>
                        </div>
                        <div className=" col-md-6">
                          <small className="form-text mt-2">Email *</small>
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="email"
                              name="Email Address"
                              id="email_address"
                              required
                              aria-label="email address"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=" col-md-12 mb-3">
                      <small className="form-text mt-2">
                        Tell Us More About You
                      </small>
                      <div className="form-group">
                        <textarea
                          className="form-control-textarea"
                          name="Tell Us More About You"
                          id="tellus"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                    <div className=" col-md-12 mb-3">
                      <div class="form-group">
                        <p className="">
                          Yes, I want to learn more about Baystreet Capital
                          Holdings. By submitting this form, I understand the
                          data I provide will be used to process my inquiry, in
                          accordance with Baystreet Capital Holdings’ privacy
                          policy.
                        </p>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <div className="webriq-recaptcha" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <button
                          className="my-3 solid-btn-homepage"
                          type="submit"
                          style={{
                            outline: "none",
                            border: "none",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </WebriQForm>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="container">
          <div className="row pt-5">
            <div className="col-sm-8 cl-logo">
              <StaticImage
                src="../../images/BAYSTREET-LOGO-WHITE.png"
                className="my_logo_img_footer"
              />
            </div>
            <div className="col-sm-4">
              <div className="social-icons">
                <a
                  href="https://www.youtube.com/channel/UCrW--z73v5yTiqbrw8QyfkA"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <StaticImage
                    className="soc_icons"
                    src="../../images/youtube.png"
                  />
                </a>
                <a
                  href="https://www.instagram.com/baystreetcapitalholdings/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <StaticImage
                    className="soc_icons"
                    src="../../images/instagram.png"
                  />
                </a>

                <a
                  href="https://www.facebook.com/baystreetcapitalholdings"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <StaticImage
                    className="soc_icons"
                    src="../../images/facebook.png"
                  />
                </a>
                <a
                  href="https://twitter.com/BayStreetSpeaks"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <StaticImage
                    className="soc_icons"
                    src="../../images/twitter.png"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/bay-street-capital-holdings/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <StaticImage
                    className="soc_icons"
                    src="../../images/linkedin.png"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="row pt-5">
            <div className="col-md mb-4">
              <span className="footer-heading">About</span>
              <div className="row">
                <Link to="/our-team/" className="footerlinks">
                  Who We Are
                </Link>
              </div>
              <div className="row">
                <Link to="/our-team/" className="footerlinks">
                  Our Team
                </Link>
              </div>
              <div className="row">
                <Link to="/careers/" className="footerlinks">
                  Careers
                </Link>
              </div>
              {/* <div className="row">
                <Link to="/partnership-opportunities/" className="footerlinks">
                  Partnership Opportunities
                </Link>
              </div> */}
            </div>
            <div className="col-md mb-4">
              <span className="footer-heading">Testimonials</span>
              <div className="row">
                <Link to="/testimonials/" className="footerlinks">
                  Testimonials
                </Link>
              </div>
            </div>
            <div className="col-md mb-4">
              <span className="footer-heading">Services</span>
              <div className="row">
                <Link to="/institutional-investors/" className="footerlinks">
                  Instutional Investors
                </Link>
              </div>
              <div className="row">
                <Link to="/services/" className="footerlinks">
                  Wealth Management
                </Link>
              </div>
              {/* <div className="row">
                <Link to="#" className="footerlinks">
                  Privacy Equity
                </Link>
              </div> */}

              {/* <div className="row">
                <Link to="#" className="footerlinks">
                  Real Estate
                </Link>
              </div> */}
              <div className="row">
                <Link to="/life-insurance/" className="footerlinks">
                  Life Insurance
                </Link>
              </div>
              <div className="row">
                <Link to="/services/" className="footerlinks">
                  Investment Banking
                </Link>
              </div>
            </div>
            <div className="col-md mb-4">
              <span className="footer-heading">Media Coverage</span>
              <div className="row">
                <Link to="/press-and-publications" className="footerlinks">
                  Media Coverage
                </Link>
              </div>
            </div>
            <div className="col-md mb-4">
              <span className="footer-heading">Insights</span>
              <div className="row">
                <Link to="/blog/" className="footerlinks">
                  Insights
                </Link>
              </div>
            </div>

            {/* <div className="col-md mb-4">
              <span className="footer-heading">Contact Us</span>
              <div className="row">
                <Link to="/" className="footerlinks">
                  Schedule an Appointment
                </Link>
              </div>
              <div className="row">
                <Link to="/" className="footerlinks">
                  Media Relations
                </Link>
              </div>
            </div> */}
          </div>
          <div className="row pt-5">
            <div className="col-md-6">
              <div className="d-flex flex-row">
                <div className="p-2">
                  <Link to="/disclosures-disclaimers/" className="footerlinks">
                    Disclosures & Disclaimers
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <ul className="list-unstyled mt-2 d-md-flex mb-0 mx-auto justify-content-md-center text-white">
                <li>
                  © {new Date().getFullYear()} Bay Street Capital Holdings. Site
                  {/* powered by{" "}
                  <a href="https://www.webriq.com" className="text-white">
                    WebriQ
                  </a> */}
                  .
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default footer
